
import { createContext, useState, useContext } from 'react';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { AlertProps, SEVERITY } from '../../shared/interfaces/alert';

const AlertContext = createContext<any>(null);

export const AlertProvider = ({ children }: any) => {
  const [open, setOpen] = useState(false);
  
  const [alertProps, setAlertProps] = useState<AlertProps>({
    message: '',
    severity: SEVERITY.INFO,
    duration: 5000,
  });

  const showAlert = (message: string, severity = SEVERITY.INFO, duration = 6000) => {
    setAlertProps({ message, severity, duration });
    setOpen(true);
  };

  const handleClose = (reason: any) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <Snackbar 
        open={open} 
        autoHideDuration={alertProps.duration} 
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleClose} 
          severity={alertProps.severity} 
          variant="filled"
          sx={{ width: '100%' }}
        >
          {alertProps.message}
        </Alert>
      </Snackbar>
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);